import { http } from '@frontend/fetch';

export const getFirebaseToken = async () => {
  return await http.get<{ token: string }>('notification/v1/token', {});
};
